import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";

import PostSingle from "../../postAdmin/PostSingle"
import PropertyComment from "../../property/PropertyComment";

const PostsCustomerDetail = () => {
  const { Id } = useParams();
  const [ownerId, setOwnerId] = useState(null);

  return (
    <> 
      <PostSingle 
        ownerId={setOwnerId} 
        back={`/dashboard/PostDashboard`} 
      /> 
      <PropertyComment 
        Id={Id}
        ownerId={ownerId}
        commentType="requestComments"
        allComments={`/property/requestComments`}
        addComment={`/property/addRequestComment`}
        editComment={`/property/editRequestComment`}
        deleteComment={`/property/deleteRequestComment/`}
      /> 
    </>
  );
}
export default PostsCustomerDetail;